<template>
    <div v-if="filteredServices.length > 0">
        <hr class="my-2">
        <div v-for="service in filteredServices" :key="service.id" class="d-flex justify-content-between align-items-center py-2">
            <span class="flex-fill">
                {{ service.name }}
                <i 
                    class="fad fa-question-circle ms-1 service-modal-tooltip text-primary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="service.short_description"
                    @click="toggleServiceExplainedModal(service)"
                ></i>
            </span>
            <span class="me-3">
                <template v-if="service.price_type === 'fixed'">&pound;{{ service.retail }}</template>

                <template v-else>
                    &pound;{{ parseFloat(service.retail * basket.total_tyres).toFixed(2) }}
                </template>
            </span>
            <button type="button" class="btn btn-primary" @click="this.$parent.addServiceToBasket(service.code, (service.price_type === 'fixed' ? 1 : basket.total_tyres))">
                Add
            </button>
        </div>
        <hr>
    </div>
</template>

<script>
    export default {
        props: ['services', 'basket'],
        data() {
            return {
                
            }
        },
        updated() {
            this.emitter.emit('refreshTooltips');
        },
        mounted() {

        },
        methods: {
            toggleServiceExplainedModal(service) {
                this.$parent.service = service;
                this.$parent.serviceExplainedModalOpen = true;
            }
        },
        computed: {
            filteredServices() {
                let vm = this;
                if(this.services.available) {
                    return this.services.available.filter((service) => {
                        return (!vm.$parent.serviceInBasket(service.code));
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .service-modal-tooltip {
        cursor: pointer;
    }
</style>